import { render, staticRenderFns } from "./RecommendationLibraryList.vue?vue&type=template&id=45bb1390&scoped=true&"
import script from "./RecommendationLibraryList.vue?vue&type=script&lang=js&"
export * from "./RecommendationLibraryList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationLibraryList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RecommendationLibraryList.vue?vue&type=style&index=1&id=45bb1390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb1390",
  null
  
)

export default component.exports